<template>
<div>
    <bar-manut 
        single-entity="Mensagem" 
        plural-entity="Mensagens Padrão" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="mennf.codmennf" :metadata="metadata.mennf.codmennf" type="text" col="2" :disabled="true"></form-field>

                <form-field v-model="mennf.descricao" type="text" col="6" :metadata="metadata.mennf.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.mennf.descricao.validator"></form-field>

                <form-field v-model="mennf.texto" type="memo" col="6" :metadata="metadata.mennf.texto" 
                    name="texto" :v-errors="errors" v-validate="metadata.mennf.texto.validator"></form-field>

            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            mennf: {...this.$store.getters.getEntities.mennf},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.mennf.codmennf)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadMennf', { id: this.index } )
            if (this.$store.getters.getMennf) {
                this.mennf = {...this.$store.getters.getMennf}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/mennf/' + this.mennf.codmennf

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/mennf/'
            var sendData = {}

            sendData = { mennf: this.mennf }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/mennf-form.vue